module.exports = __webpack_public_path__ + "static/media/6C.faf8a23c.svg";